import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetStats = ({ year }: { year: number }) => {
  return HTTP_CLIENT.get(Endpoint.dashboard.getStats + `?year=${year}`);
};

const GetLatestUsers = () => {
  return HTTP_CLIENT.get(Endpoint.dashboard.getNewUsers);
};

export { GetStats, GetLatestUsers };
